import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGroup = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 1.75a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5M8.75 4.5a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0M4.5 7.25a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5M3.25 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4 5.5a2.75 2.75 0 1 1 5.5 0 2.75 2.75 0 0 1-5.5 0M10 14.25a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m5.5-7a2.75 2.75 0 1 0 0 5.5 2.75 2.75 0 0 0 0-5.5M14.25 10a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgGroup;
